import React, { Component } from 'react';
import "./button.css";


class Button extends Component {
  constructor(props){
      super(props);
   }
  render() {
    let classlist;
    //let activeClass = this.props.selected?'active':'';
    classlist = `btn ${this.props.classList?this.props.classList:''}`

    return (
      <button type={this.props.btnType} onClick={()=>this.props.btnClick()} className={classlist}>{this.props.children}</button>
    )
  }
}

export default Button;
